export const REFRESH_INTERVAL = 5000;
export const AVATAR_SIZE = 35;
